import React, { useMemo } from "react";
import { useTheme } from "themes/useTheme";
import styles from "./Logo.module.css";
import { Link } from "react-router-dom";
import useSizeMediaQuery from "hooks/useSizeMediaQuery";

const Logo = ({ titleVisible = true }: { titleVisible?: boolean }) => {
  const { themeVariables } = useTheme();

  const size = useSizeMediaQuery();

  const isMobile = useMemo(() => ["xs", "sm"].includes(size), [size]);

  return (
    <Link
      to="/"
      className={styles["logo-container"]}
      style={{ backgroundColor: themeVariables.background_color }}
    >
      <img
        src={require("assets/logo.png")}
        alt="Tiki AFF"
        className={styles["logo-img"]}
      />
      {titleVisible && (
        <span className={styles["logo-title"]}>
          {isMobile ? "TIKI AFF" : "TIKI AFFILIATE"}
        </span>
      )}
    </Link>
  );
};

export default React.memo(Logo);
